// src/jsx/pages/SelectPanchayath.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TenantSwitcher from "../components/common/TenantSwitcher";
import { fetchMyPermissionsThunk } from "../../store/slices/permissionSlice";

export default function SelectPanchayath() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = useSelector((s) => s.auth?.user?.role);
  const isSuperadmin = String(role || "").toLowerCase() === "superadmin";

  const pan_id = useSelector((s) => Number(s.tenant?.pan_id || 0));
  const pan_ids = useSelector((s) => s.tenant?.pan_ids || []);

  const hasTenant = (pan_id > 0) || (Array.isArray(pan_ids) && pan_ids.length > 0);

  // If not superadmin, no need this page
  useEffect(() => {
    if (!isSuperadmin) navigate("/dashboard");
  }, [isSuperadmin, navigate]);

  const onContinue = async () => {
    if (!hasTenant) return;
    await dispatch(fetchMyPermissionsThunk()).unwrap();
    navigate("/dashboard");
  };

  return (
    <div className="container py-4">
      <h4 className="mb-3">Select Panchayath</h4>

      <div className="mb-3">
        <TenantSwitcher />
      </div>

      <button
        className="btn btn-primary"
        disabled={!hasTenant}
        onClick={onContinue}
      >
        Continue
      </button>

      {!hasTenant && (
        <div className="text-muted mt-2" style={{ fontSize: 13 }}>
          Please choose a Panchayath (or “All Linked”) to continue.
        </div>
      )}
    </div>
  );
}
